import React from 'react';

const ProductFilters = ({ clientes, clienteSeleccionado, onClientChange, onFilter, filtros, onReset }) => {
  return (
    <div className="flex flex-col md:flex-row gap-2 items-center">
      <select
        className="border rounded px-2 py-1"
        value={clienteSeleccionado || ''}
        onChange={e => onClientChange(e.target.value)}
      >
        <option value="">Todos los clientes</option>
        {clientes && clientes.map(cliente => (
          <option key={cliente.id} value={cliente.id}>{cliente.nombre}</option>
        ))}
      </select>
      <input
        className="border rounded px-2 py-1"
        type="text"
        placeholder="Buscar producto, SKU, código..."
        value={filtros.busqueda || ''}
        onChange={e => onFilter({ ...filtros, busqueda: e.target.value })}
      />
      <button className="btn-secondary" onClick={onReset}>Limpiar</button>
    </div>
  );
};

export default ProductFilters;
